module.exports = __webpack_public_path__ + "img/successBig.dd8bab83.svg";